export const getVisibleLfcDimensionsIds = (dimensions: any[], lfcDimensionsVisibilityJson: any[]): any[] =>
  dimensions.flatMap((dim) =>
    lfcDimensionsVisibilityJson.some(
      (ruleObj) => ruleObj.dimensionCode === dim.dimensionCode && ruleObj.visibility === 'VISIBLE'
    )
      ? [dim.dimensionId]
      : []
  )
